<template>
  <div>
    <div class="text-h6 mt-2 mb-3 d-block d-md-none">
      <v-icon color="grey" style="margin-bottom: 3px;">mdi-cog</v-icon>
      {{ $t('title') }}
    </div>
    <v-row>
      <v-col cols="12" md="8" style="margin: auto;">
        <locales class="mb-4"></locales>
        <notifications class="mb-4"></notifications>
        <application class="mb-4"></application>
      </v-col>
    </v-row>

    <domain-completion-dialog></domain-completion-dialog>
    <keyword-completion-dialog></keyword-completion-dialog>
  </div>
</template>

<script>
import Locales from '@/views/Pages/Account/Preferences/Components/Locales'
import Application from '@/views/Pages/Account/Preferences/Components/Application'
import KeywordCompletionDialog from '@/views/Pages/Account/Preferences/Dialogs/KeywordCompletionDialog'
import DomainCompletionDialog from '@/views/Pages/Account/Preferences/Dialogs/DomainCompletionDialog'
import Notifications from '@/views/Pages/Account/Preferences/Components/Notifications'

export default {
  name: 'PreferencesPage',
  components: { Notifications, DomainCompletionDialog, KeywordCompletionDialog, Application, Locales },

}
</script>

<i18n>
{
	"en": {
		"title": "Preferences"
	},
	"es": {
		"title": "Preferencias"
	},
	"fr": {
		"title": "Préférences"
	},
	"it": {
		"title": "Preferenze"
	},
	"pt": {
		"title": "Preferências"
	},
	"pl": {
		"title": "Preferencje"
	}
}
</i18n>
